export default "__VITE_ASSET__ByfuPW_6__"